

// ------------------ PRANK NEWS GENERATOR ---------------

const page_title = "New World Record holder for largest Man Tits Announced! – slappywares";

const notification_fadeOut_time = 3000;

//Get our URL
const baseUrl = window.location.href.split('?')[0];
let imgUrl = '';


// Get DOM elements
const firstInput = document.getElementById('first-input');
const lastInput = document.getElementById('last-input');
const generatedUrl = document.getElementById('generated_prankUrl');
const copyButton = document.getElementById('generated_prankUrl_copyButton');

let interval_ms_count = 0;
const interval_keystroke_ms_add = 50;

let interval_keystroke_listening_on = false;
let interval_keystroke_listening_ms_tick = 500;

//set the year for an evergreen copyright
document.querySelector('.date_now').textContent = new Date().getFullYear();

// Event listeners for input changes
firstInput.addEventListener('input', dom_updateUrl);
lastInput.addEventListener('input', dom_updateUrl);


//------------- LOGIN LINK ----------

//TODO - this redirect doesn't work just yet. Redo later.
const login_url = 
  "/account/login?return_to=" +
  encodeURIComponent(window.location.pathname + window.location.search);

let ref = document.querySelector("#prank_login");

if (ref) {
  ref.addEventListener("click", 
    function() {
      window.location.href = login_url;
    }
  );
}



//-------- KEYSTROKE INTERVAL LISTENER ----------

setInterval(()=> {

  //console.log("interval - interval_keystroke_listening_on: " + interval_keystroke_listening_on);

  //if we're not listening - don't bother
  if (
    !interval_keystroke_listening_on ||
    interval_keystroke_listening_on === undefined
  ) { return; }

  //console.log("interval - interval_ms_count: " + interval_ms_count);

  //we're counting down
  interval_ms_count -= interval_keystroke_ms_add * 1.5;


  if (interval_ms_count <= 0) {
    
    //notification
    NotificationManager.success('Article updated. Scroll up to see!', 'Updated', notification_fadeOut_time);

    //turn off listening
    interval_keystroke_listening_on = false;

    //reset this just in case we went negative
    interval_ms_count = 0;
    
  }//end if
  
},interval_keystroke_listening_ms_tick);
//end interval



//------------ CLIPBOARD COPY ---------------

copyButton.addEventListener('click', () => {
  const urlText = generatedUrl.textContent;
  navigator.clipboard.writeText(urlText)
    .then(() => {
      NotificationManager.success('URL copied to clipboard!', 'Success!!', notification_fadeOut_time);
    })
    .catch(err => {
      console.error('Failed to copy: ', err);
      NotificationManager.error('Weird. Failed to copy URL. Please copy it manually.', 'ERROR!!', notification_fadeOut_time);
    });
});




//-------- FILE UPLOAD ----------

const fileInput = document.getElementById('imageUpload');

if (fileInput) {
  fileInput.addEventListener('change', (event) => {
    console.log("file input change event");
    uploadImage();
  });
}



//------------ AWS config ------------

AWS.config.region = 'us-east-2';
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: window.identityPoolId
});

const s3 = new AWS.S3();


//------------- AWS S3 IMAGE upload -----------
async function uploadImage() {

  console.log("uploadImage()");
  
  const file = document.getElementById('imageUpload').files[0];
  const status = document.getElementById('status');

  //--- no file -----
  if (!file) {
    status.textContent = 'Hmm, there\'s no file';
    return;
  }

  //---- 2MB file size limit ------
  if (file.size > 2 * 1024 * 1024) {
    status.textContent = 'Invalid file! Max 2MB.';
    return;
  }

  //UI msg update
  status.textContent = 'Uploading...';
  
  const key = `pranks/${Date.now()}-${file.name}`;

  AWS.config.credentials.get(
    
    async (err) => {
    
      if (err) {
        
        //UI msg update
        status.textContent = 'Auth error: ' + err;
        return;
        
      }

      const params = {
        Bucket: 'slappytees-pranks-2025',
        Key: key,
        Body: file,
        ContentType: file.type
      };
  
      try {
        
        const { Location } = await s3.upload(params).promise();

        //remember this
        imgUrl = Location;

        //UI msg update
        status.textContent = "It's in the page! Scroll up LOL!";

        NotificationManager.success('Your image was added! Scroll up LOL!', 'Success!!', notification_fadeOut_time);

        const firstValue = encodeURIComponent(firstInput.value.trim());
        const lastValue = encodeURIComponent(lastInput.value.trim());

        const prankUrl = `${window.location.pathname}?first=${firstValue}&last=${lastValue}&img=${encodeURIComponent(Location)}`

        window.history.pushState({}, page_title, prankUrl);
    
        //DOM - update image srcs
        dom_updateImage(Location)

        //DOM - update shareable URL text
        dom_updateUrl(keystroke_listen_toggle = false)
        
      } catch (error) {
        status.textContent = 'Error: ' + error.message;
      }
      //end try/catch
      
    }//end async
    
  );//end AWS credentials get
  
}//end f



// Function to update the URL
function dom_updateUrl(keystroke_listen_toggle = true) {

  //console.log("dom_updateUrl()");

  if (keystroke_listen_toggle) {
    //turn on keystroke lisetning
    interval_keystroke_listening_on = true;
  }

  //if it's 0 give us a decent buffer
  if (interval_ms_count === 0) {
    
    interval_ms_count += 300;
    
  } else {
    
    //add ms for each keystroke
    interval_ms_count += interval_keystroke_ms_add;
    
  }//end if/else

  
  const firstValue = encodeURIComponent(firstInput.value.trim());
  const lastValue = encodeURIComponent(lastInput.value.trim());

  //console.log("dom_updateUrl() - firstValue: " + firstValue);
  //console.log("dom_updateUrl() - lastValue: " + lastValue);
  
  let queryString = `?first=${firstValue}&last=${lastValue}`;

  let obj = getUrlParams();
  
  console.dir(obj);

  let first_param = firstValue;
  let last_param = lastValue;
  
  //catch a preview or first run
  if (firstValue.length === 0 && lastValue.length === 0) {
    
    if (obj.first.length > 0 || obj.last.length > 0) {
      queryString = `?first=${obj.first}&last=${obj.last}&img=${obj.img}`;
    }

    firstInput.value = obj.first;
    lastInput.value = obj.last;

    first_param = obj.first;
    last_param = obj.last;
    
  }

  if (obj.img.length > 0) {
    queryString += `&img=${obj.img}`;
  }

  // Build the new URL with query parameters
  const baseUrl = window.location.origin + window.location.pathname; // Keeps the current page path
  const newUrl = `${baseUrl}?first=${encodeURIComponent(first_param)}&last=${encodeURIComponent(last_param)}&img=${obj.img}`;

  // Update the URL without reloading the page
  window.history.pushState({}, document.title, newUrl);

  //DOM - update copyable URL
  generatedUrl.textContent = baseUrl + queryString;

  //DOM - update inputs
  dom_updateSpans()
  
}//end f


// ------------------ PAGE LOAD DATA ---------------

function getUrlParams() {
  
  const params = new URLSearchParams(window.location.search);
  
  return {
    first: params.get('first') || '*first name here*',
    last: params.get('last') || '*last name here*',
    img: params.get('img') || ''
  };
  
}//end f


function init_page() {

  //console.log("init_page()");

  const firstValue = firstInput.value.trim();
  const lastValue = lastInput.value.trim();

  console.log(firstValue.length);
  console.log(lastValue.length);

  dom_updateSpans();

  let img_url = param_getImageUrl();
  
  if (img_url.length > 0) {
    dom_updateImage(img_url);
  }
  
}//end f


function dom_updateSpans() {

  const firstValue = firstInput.value.trim();
  const lastValue = lastInput.value.trim();
  
  document.querySelectorAll('.data_first').forEach(span => {
    span.textContent = firstValue;
  });
  document.querySelectorAll('.data_last').forEach(span => {
    span.textContent = lastValue;
  });
          
}//end f


function param_getImageUrl() {
  // Safely parse the current URL, fallback to empty string if it fails
  const urlObj = new URL(window.location.href || '');
  
  // Get 'img' param, default to empty string if null/undefined
  const imgUrl = urlObj.searchParams.get("img") ?? '';
  
  // Decode if it exists and has length, otherwise return empty string
  return imgUrl ? decodeURIComponent(imgUrl) : '';
  
}//end f



function dom_updateImage (new_imgUrl) {

  //console.log("dom_updateImage()");
  
  //get all the images with class="prankImage" and set srcs
  document.querySelectorAll('.prankImage').forEach(img => {
    img.src = new_imgUrl;
  });
  
}//end f


window.addEventListener('load', function() {
  try {
    console.log("load");
    init_page();
  } catch (e) {
    console.error("Error in load handler:", e);
  }
});


// Initialize URL on page load
dom_updateUrl(false);